// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"0e57fa87","286":"2ec2ffea","628":"2ec2ffea","710":"f14e183d"}[chunkId] + ".chunk.css";
};